<template>
  <v-container>
    <v-layout justify-center>
      <v-flex xs12 md8 lg6>
        <barcode
          title="Watch Grading"
          subtitle="Scan or Enter a Serial Number"
          buttonText="Search Repair Orders"
          @search="searchRepairs"
        />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LoginCheck from "@/mixins/LoginCheck";
import Barcode from "@/components/app/Barcode";

export default {
  name: "watch-grading",
  data() {
    return {};
  },

  components: {
    Barcode
  },

  mixins: [LoginCheck],

  computed: {
    ...mapGetters({
      repair: "repair/getRepair"
    })
  },

  methods: {
    ...mapActions({
      repairSearch: "repair/searchServices"
    }),

    async searchRepairs(barcodeValue) {
      await this.repairSearch({ serial: barcodeValue.trim() });

      if (this.repair.length) {
        let urlEncoded = encodeURIComponent(barcodeValue.trim());
        this.$router.push(`/watch-grading/${urlEncoded}`);
      } else {
        this.$store.dispatch("app/setSnackbar", {
          text: "No repair order found!",
          color: "red"
        });
      }
    }
  }
};
</script>

<style></style>
